<template>
  <div class="animated fadeIn">
    <div class="row">
      <div class="col-lg-12">
        <div class="col-lg-10 pl-0">
          <button @click="addOnePastMonth">Extra period before</button>
          <button @click="addOneFutureMonth">Extra period after</button>
        </div>
        <div class="card" v-if="projects[id]">
          <div class="card-header">
            <i class="fa fa-align-justify"></i> {{ projects[id].name }}
          </div>
          <div class="card-block">
            <!--<div class="row" v-if="financeOverview[curColumnIndex-1]">-->
            <!--<div class="col-md-6">-->
            <!--<label>Current budget:</label>-->
            <!--{{Math.round(financeOverview[curColumnIndex-1].budget)}}-->
            <!--</div>-->
            <!--<div class="col-md-6">-->
            <!--<label>Current month expenses:</label>-->
            <!--{{Math.round(financeOverview[curColumnIndex-1].expenses)}}-->
            <!--</div>-->
            <!--</div>-->
            <div class="table-wrapper">
              <div class="t">
                <table class="table">
                  <tr>
                    <td class="td-header-padding table-head-cell">Date</td>
                    <td :class="['text-right text-monospace table-head-cell', ...data.classes]"
                      v-for="data in financeOverview" :key="`month${data.yearmonth}`">{{ data.month }}</td>
                  </tr>
                  <tr>
                    <td class="td-header-padding table-head-cell">Remaining Budgeted cost</td>
                    <td :class="['text-right text-monospace table-numbers', ...data.classes]"
                      v-for="data in financeOverview" :key="`budget${data.yearmonth}`">
                      {{ numberWithSpaces(Math.round(data.budget)) }}</td>
                  </tr>
                  <tr>
                    <td class="td-header-padding table-head-cell">Actual Cost Labour</td>
                    <td :class="['text-right text-monospace table-numbers', ...data.classes]"
                      v-for="data in financeOverview" :key="`labourCosts${data.yearmonth}`">
                      {{ numberWithSpaces(Math.round(data.labourCosts)) }}</td>
                  </tr>
                  <tr>
                    <td class="td-header-padding table-head-cell">Actual Cost Materials</td>
                    <td :class="['text-right text-monospace table-numbers', ...data.classes]"
                      v-for="data in financeOverview" :key="`materialCosts${data.yearmonth}`">
                      {{ numberWithSpaces(Math.round(data.materialCosts)) }}</td>
                  </tr>
                  <tr>
                    <td class="td-header-padding table-head-cell">Actual Cost Labour+Materials</td>
                    <td :class="['text-right text-monospace table-numbers', ...data.classes]"
                      v-for="data in financeOverview" :key="`totalCosts${data.yearmonth}`">
                      {{ numberWithSpaces(Math.round(data.totalCosts)) }}</td>
                  </tr>
                  <tr>
                    <td class="td-header-padding table-head-cell">Revenue</td>
                    <td :class="['table-numbers-input', ...data.classes]" v-for="data in financeOverview"
                      :key="`revenue${data.yearmonth}`">
                      <input class="text-right text-monospace input-cell" @change="saveMonthRevenue(data)"
                        v-model="data.revenue" type="text">
                      <!--{{Math.round(data.revenue)}}-->
                    </td>
                  </tr>
                  <tr>
                    <td class="td-header-padding table-head-cell">Profit</td>
                    <td :class="['text-right text-monospace table-numbers', ...data.classes]"
                      v-for="data in financeOverview" :key="`profit${data.yearmonth}`">
                      {{ numberWithSpaces(Math.round(data.profit)) }}</td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!--/.col-->
    </div>
    <!--/.row-->
  </div>
</template>
<style lang="scss" scoped>
.z-0 {
  z-index: 0;
}

table * {
  white-space: nowrap;
}

.t {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  overflow-x: scroll;
}

.table-wrapper table .table-numbers-input input {
  padding-bottom: 0px;
  line-height: 100%;
  padding-right: 0.1rem;
}

.table-wrapper table .table-numbers-input {
  padding: 0 !important;
}

.table-wrapper {
  position: relative;
  width: 100%;
  height: 200px;
}

.table-wrapper table * {
  padding: 0.1rem 0.2rem 0.1rem 0.1rem;
  text-align: left;
}

input {
  width: 100%;
}

.td-header-padding {
  padding-right: 5px !important;
}

td.current {
  background-color: #e0e0ff;
}

td.nearcurrent {
  background-color: #ffe0e0;
}
</style>

<script>
import { mapGetters, mapActions } from 'vuex';
import moment from 'moment';
import VueNotifications from 'vue-notifications';
import ProjectWorklogs from './ProjectWorklogs';
import IncomingPayments from './IncomingPayments';
// import {GoogleCharts} from 'google-charts';
import ProjectGraph from './ProjectGraph';
import Projects from './Projects';
import VacationPlanner from './VacationPlanner';
import PlannedPeriodTimeline from './PlannedPeriodTimeline';
import Invoices from '../documents/Invoices';
import ProjectGraphics from './ProjectGraphics.vue';

export default {
  name: 'BudgetTable',
  props: {
    projectId: {
      default: null
    }
  },
  components: {
    ProjectWorklogs,
    IncomingPayments,
    Invoices,
    ProjectGraph,
    Projects,
    VacationPlanner,
    PlannedPeriodTimeline,
    ProjectGraphics
  },
  data: function () {
    return {
      id: (this.projectId) ? this.projectId : this.projectId,
      curColumnIndex: null,
      startDate: moment().startOf('year').format('YYYY-MM-DD'),
      extraPastMonths: 0,
      extraFutureMonths: 0,
    };
  },
  watch: {
    // financeOverview() {
    //   if (!this.projects[this.id]) return;
    //   const curDate = new Date(this.projects[this.id].start_date);
    //   const endDate = new Date(this.projects[this.id].end_date);
    //   const yearmonth = moment(curDate).format('YYYYM');
    //   let i = 1;
    //   while (curDate <= endDate) {
    //     if (yearmonth === moment().format('YYYYM')) this.curColumnIndex = i;
    //     curDate.setMonth(curDate.getMonth() + 1);
    //     i++;
    //   }

    //   // if (!this.curColumnIndex) return;
    //   // $(`.table-wrapper table td:nth-child(-n+${this.curColumnIndex}):not(:first-child)`).css('background-color', '#ffe0e0');
    //   // $(`.table-wrapper table td:nth-child(${this.curColumnIndex + 1})`).css('background-color', '#e0e0ff');
    //   // $(`.table-wrapper table td:nth-child(n+${this.curColumnIndex + 2})`).css('background-color', '#e0ffe0');
    // },
    revenuePerMonthNotification: {
      handler() {
        if (this.revenuePerMonthNotification.status == 'success') {
          this.showSuccessMsg({ title: 'Revenue save status!', message: this.revenuePerMonthNotification.message });
        }
        if (this.revenuePerMonthNotification.status == 'error') {
          for (const i in this.revenuePerMonthNotification.message) {
            this.showErrorMsg({
              title: 'Revenue save status!',
              message: this.revenuePerMonthNotification.message[i]
            });
          }
        }
      },
      deep: true
    }
  },
  computed: {
    ...mapGetters('JiraProjects', ['projects']),
    ...mapGetters('ProjectFinances', ['labourCostsByProjectByMonth', 'plannedLabourCostsByProjectByMonthAfterToday', 'materialCostsByProjectByMonth']),
    ...mapGetters('RevenuePerMonth', ['revenuePerMonthNotification', 'revenueByProjectPerMonth']),
    financeOverview() {
      const t = [];
      if (!this.projects[this.id]) return;
      const curDate = new Date(this.startDate);
      curDate.setMonth(curDate.getMonth() - this.extraPastMonths);
      let endDate = new Date(this.startDate);
      endDate.setMonth(endDate.getMonth() + 11 + this.extraFutureMonths);


      const labourCosts = this.labourCostsByProjectByMonth[this.id] || {};
      const plannedLabourCosts = this.plannedLabourCostsByProjectByMonthAfterToday[this.id] || {};
      const materialCosts = this.materialCostsByProjectByMonth[this.id] || {};
      const revenue = this.revenueByProjectPerMonth[this.id] || {};

      let totalCosts = 0;
      const project = this.projects[this.id];
      while (curDate <= endDate) {
        const yearmonth = moment(curDate).format('YYYYM');
        const classes = [];
        if (yearmonth === moment().format('YYYYM')) classes.push('current');
        if (moment(curDate).add(-1, 'month').format('YYYYM') === moment().format('YYYYM')
          || moment(curDate).add(+1, 'month').format('YYYYM') === moment().format('YYYYM')) classes.push('nearcurrent');
        // if (yearmonth === moment().format('YYYYM')) this.curColumnIndex = i;
        const expenses = ((labourCosts[yearmonth] || 0) + (plannedLabourCosts[yearmonth] || 0) + (materialCosts[yearmonth] || 0)) / 100;
        totalCosts += ((labourCosts[yearmonth] || 0) + (plannedLabourCosts[yearmonth] || 0) + (materialCosts[yearmonth] || 0)) / 100;
        t.push({
          month: moment(curDate).format('MMM YYYY'),
          date: moment(curDate).startOf('month').format('YYYY-MM-DD'),
          yearmonth: yearmonth,
          classes: classes,
          budget: this.budgetAtDate(project, curDate),
          expenses: expenses,
          labourCosts: ((labourCosts[yearmonth] || 0) + (plannedLabourCosts[yearmonth] || 0)) / 100,
          materialCosts: (materialCosts[yearmonth] || 0) / 100,
          totalCosts: this.totalCostsAtDate(project, curDate),
          revenue: (revenue[yearmonth] || 0) / 100,
          profit: (revenue[yearmonth] || 0) / 100 - totalCosts,
        });
        curDate.setMonth(curDate.getMonth() + 1);
      }
      return t;
    },
  },
  methods: {
    ...mapActions('RevenuePerMonth', ['SAVE_MONTH_REVENUE']),
    saveMonthRevenue(data) {
      data.project_id = this.projectId;
      this.SAVE_MONTH_REVENUE(data);
    },
    numberWithSpaces(x) {
      return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
    },
    addOneFutureMonth() {
      if (this.extraFutureMonths < 6) {
        this.extraFutureMonths += 1;
      }
    },
    addOnePastMonth() {
      if (this.extraPastMonths < 6) {
        this.extraPastMonths += 1;
      }
    },
    budgetAtDate(project, date) {
      let budget = project.baseline_costs + project.contingency;
      let iterationDate = moment(project.start_date).startOf('month')

      const labourCosts = this.labourCostsByProjectByMonth[project.id] || {};
      const plannedLabourCosts = this.plannedLabourCostsByProjectByMonthAfterToday[project.id] || {};
      const materialCosts = this.materialCostsByProjectByMonth[project.id] || {};

      while (iterationDate <= date) {
        for (const changeRequest of project.change_requests) {
          const changeRequestStartDate = moment(changeRequest.start_date);
          if (changeRequestStartDate.month() === iterationDate.month() && changeRequestStartDate.year() === iterationDate.year()) {
            budget += changeRequest.baseline_costs;
          }
        }

        const yearmonth = moment(iterationDate).add(-1, 'month').format('YYYYM');
        const expenses = ((labourCosts[yearmonth] || 0) + (plannedLabourCosts[yearmonth] || 0) + (materialCosts[yearmonth] || 0)) / 100;

        budget -= expenses;
        iterationDate.add(1, 'month');
      }

      return budget;
    },
    totalCostsAtDate(project, date) {
      let totalCosts = 0;
      let iterationDate = moment(project.start_date).startOf('month');

      const labourCosts = this.labourCostsByProjectByMonth[project.id] || {};
      const plannedLabourCosts = this.plannedLabourCostsByProjectByMonthAfterToday[project.id] || {};
      const materialCosts = this.materialCostsByProjectByMonth[project.id] || {};

      while (iterationDate <= date) {
        const yearmonth = moment(iterationDate).format('YYYYM');
        totalCosts += ((labourCosts[yearmonth] || 0) + (plannedLabourCosts[yearmonth] || 0) + (materialCosts[yearmonth] || 0)) / 100;
        iterationDate.add(1, 'month');
      }
      return totalCosts;
    }
  },
  notifications: {
    showSuccessMsg: {
      type: VueNotifications.types.success
    },
    showInfoMsg: {
      type: VueNotifications.types.info
    },
    showWarnMsg: {
      type: VueNotifications.types.warn
    },
    showErrorMsg: {
      type: VueNotifications.types.error
    }
  },
  mounted() {
  },
};
</script>
